import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildAddresses } from './addressesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Addresses({ addresses, owner, showSummary = true }) {
    const model = useMemo(() => buildAddresses(addresses, owner), [addresses, owner])
    if (!model.rows.length) return <div className={styles.calmLine}>No addresses found.</div>
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone='neutral'>{plural(model.summary.count, 'address', 'addresses')}</Badge>
                    {model.summary.risky > 0 && <Badge tone='watch' dot>{model.summary.risky} high risk</Badge>}
                </div>
            )}
            <RecordList items={model.rows} />
        </div>
    )
}
